import classNames from 'classnames';
import { omit } from 'lodash-es';
import type { DetailedHTMLProps, HTMLAttributes } from 'react';
import { Tooltip } from '../../tooltip';
import type { IconComponent } from '../../types';

type NativeSpanProps = DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>;

type TagVariant = 'Neutral' | 'Attention' | 'Negative' | 'Positive';

type TagProps = NativeSpanProps & {
  Icon?: IconComponent;
  iconOnly?: boolean;
  variant: TagVariant;
  text: string;
};

const Tag = (props: TagProps) => {
  const tag = (
    <div {...omit(props, 'Icon', 'variant', 'text', 'className', 'iconOnly')} className={classNames(
      'tds-tag inline-flex items-center gap-50',
      {
        'px-1': props.iconOnly,
        'tds-tag-attention': props.variant === 'Attention',
        'tds-tag-neutral': props.variant === 'Neutral',
        'tds-tag-positive': props.variant === 'Positive',
        'tds-tag-negative': props.variant === 'Negative',
      },
      props.className,
    )}>
      {props.Icon ? <props.Icon size="1rem" /> : null}
      <span className={classNames({ 'sr-only': props.iconOnly })}>{props.text}</span>
    </div>
  );
  return props.iconOnly ? (<Tooltip content={props.text}>{tag}</Tooltip>) : tag;
};

export const TagAttention = (props: Omit<TagProps, 'variant'>) => (
  <Tag {...props} variant="Attention" />
);

export const TagNeutral = (props: Omit<TagProps, 'variant'>) => (
  <Tag {...props} variant="Neutral" />
);

export const TagPositive = (props: Omit<TagProps, 'variant'>) => (
  <Tag {...props} variant="Positive" />
);

export const TagNegative = (props: Omit<TagProps, 'variant'>) => (
  <Tag {...props} variant="Negative" />
);
